<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30">
    <div class="card bd-gray-400">
      <div class="list-wrap">
        <!-- 表头 -->
        <div class="list-heard d-flex mg-b-5">
          <div class="d-flex pd-x-5 flex-1">
            <div class="c-4 tx-white">
              <label class="ckbox mg-b-0 d-inline-block valign-middle">
                <input
                  type="checkbox"
                  :checked="isAll"
                  @change="changeAllCheck($event)"
                />
                <span></span>
              </label>
              {{ $t("financial.对账单编号/对账单名称") }}
            </div>
            <div class="c-2 tx-white">{{ $t("financial.结算类型") }}</div>
            <div class="c-2 tx-white">{{ $t("financial.客户") }}</div>
            <div class="c-2 tx-white">{{ $t("financial.结算订单数") }}</div>
            <div class="c-3 tx-white">
              {{ $t("financial.货款/运费/预计应结金额") }}
            </div>
            <div class="c-3 tx-white">
              {{ $t("financial.实际需结金额/实际已结金额") }}
            </div>
            <div class="c-2 tx-white">{{ $t("financial.备注") }}</div>
            <div class="c-2 tx-white">{{ $t("financial.结算状态") }}</div>
            <div class="c-2 tx-white">{{ $t("financial.结算日期") }}</div>
            <div class="c-2 tx-white">{{ $t("financial.操作") }}</div>
          </div>
        </div>
        <!-- 列表 -->
        <div
          v-for="item in items"
          :key="item.id"
          class="list-body d-flex mg-b-10"
        >
          <div class="flex-1 pd-x-5 product-table card bd-gray-400 pd-5">
            <!-- 父对账单数据 -->
            <div class="d-flex align-items-center">
              <div class="c-4 valign-middle tx-12">
                <div class="media d-flex align-items-center pos-relative">
                  <label class="ckbox mg-b-0 d-inline-block valign-middle">
                    <input
                      type="checkbox"
                      :value="item.id"
                      v-model="checkArr"
                    />
                    <span></span>
                  </label>
                  <div id="">
                    <p class="mg-b-5">{{ item.code ? item.code : "---" }}</p>
                    <p class="mg-b-5 d-flex align-items-center">
                      <span
                        class="d-block tx-ellipsis1"
                        :title="item.name"
                        style="max-width: 200px"
                        >{{ item.name ? item.name : "---" }}</span
                      >
                      <a
                        v-if="item.name"
                        href="javascript:;"
                        class="mg-l-5 to-clipboard"
                        :data-clipboard-text="item.name"
                      >
                        <i class="icon ion-clipboard"></i>
                      </a>
                    </p>
                    <p class="mg-b-0">
                      <span
                        class="tx-underline"
                        @click="openLog(item)"
                        style="cursor: pointer"
                        >{{ $t("financial.(操作日志)") }}</span
                      >
                    </p>
                  </div>
                </div>
              </div>
              <div class="c-2 tx-left valign-middle tx-12">
                <div v-if="item.billType == 1">
                  <p class="mg-b-5 tx-white">{{ $t("financial.周期结算") }}</p>
                  <p class="mg-b-5 tx-white">
                    {{ item.billDateFrom }}
                    <span class="tx-white-4">~</span>
                  </p>
                  <p class="mg-b-0 tx-white">{{ item.billDateTo }}</p>
                </div>
                <div v-if="item.billType == 2">
                  <p class="mg-b-5 tx-white">
                    {{ $t("financial.按单结算") }}
                    <i
                      class="icon ion-information-circled tx-gray-600"
                      @mouseenter="popContact($event, item, 'showSettleMethod')"
                      @mouseleave="popContact($event)"
                    ></i>
                  </p>
                  <div class="mg-b-0 tx-white" v-if="item.paymentJson">
                    <p class="mg-b-5" v-if="item.paymentJson.deliverBefore">
                      {{ item.paymentJson.deliverBefore }}%:{{
                        ($CE[item.currency] || {}).symbol
                      }}{{
                        formatNum(
                          (item.realAmount * item.paymentJson.deliverBefore) /
                            100,
                          4
                        )
                      }}
                    </p>
                    <p class="mg-b-5" v-if="item.paymentJson.allReceived">
                      {{ item.paymentJson.allReceived }}%:{{
                        ($CE[item.currency] || {}).symbol
                      }}{{
                        formatNum(
                          (item.realAmount * item.paymentJson.allReceived) /
                            100,
                          4
                        )
                      }}
                    </p>
                    <p class="mg-b-5" v-if="item.paymentJson.receivedAfter">
                      {{ item.paymentJson.receivedAfter }}%:{{
                        ($CE[item.currency] || {}).symbol
                      }}{{
                        formatNum(
                          (item.realAmount * item.paymentJson.receivedAfter) /
                            100,
                          4
                        )
                      }}
                    </p>
                  </div>
                </div>
                <div v-if="item.billType == 3">
                  <p class="mg-b-5 tx-white">{{ $t("financial.寄售结算") }}</p>
                  <p class="mg-b-5 tx-white">
                    {{ item.billDateFrom }}
                    <span class="tx-white-4">~</span>
                  </p>
                  <p class="mg-b-0 tx-white">{{ item.billDateTo }}</p>
                </div>
              </div>
              <div class="c-2 valign-middle tx-14">
                <p class="mg-b-0 tx-white">
                  {{ item.distributorName }}
                </p>
              </div>
              <div class="c-2 valign-middle tx-14">
                <a
                  class="tx-info"
                  href="javascript:;"
                  @click="openOrderList(item)"
                  >{{ item.orderCnt }}{{ $t("financial.个采购单") }}</a
                >
                <br/>
                <a
                  class="tx-primary tx-12"
                  href="javascript:;"
                  @click="attachment(item)"
                  >{{ $t("financial.上传/查看附件") }}</a
                >
              </div>
              <div class="c-3 valign-middle tx-12">
                <p class="mg-b-5">
                  {{ $t("financial.货款：") }}
                  <span class="tx-white">{{
                    ($CE[item.currency] || {}).symbol +
                    formatNum(item.productAmount, 4)
                  }}</span>
                </p>
                <p class="mg-b-5">
                  {{ $t("financial.运费：") }}
                  <span class="tx-white">{{
                    ($CE[item.currency] || {}).symbol +
                    formatNum(item.shippingAmount, 4)
                  }}</span>
                </p>
                <p class="mg-b-5">
                  {{ $t("financial.其他费用：") }}
                  <span class="tx-white">{{
                    ($CE[item.currency] || {}).symbol +
                    formatNum(item.otherAmount, 4)
                  }}</span>
                </p>
                <p class="mg-b-0">
                  {{ $t("financial.预计应结金额：") }}
                  <span class="tx-white">{{
                    ($CE[item.currency] || {}).symbol +
                    formatNum(item.totalAmount, 4)
                  }}</span>
                </p>
              </div>
              <div class="c-3 valign-middle tx-12">
                <p class="mg-b-5">
                  {{ $t("financial.需结：") }}
                  <span class="tx-white">{{
                    ($CE[item.currency] || {}).symbol +
                    formatNum(item.realAmount, 4)
                  }}</span>
                </p>
                <p class="mg-b-5">
                  {{ $t("financial.已结：") }}
                  <span class="tx-white">{{
                    ($CE[item.currency] || {}).symbol +
                    formatNum(item.partAmount, 4)
                  }}</span>
                </p>
                <p class="mg-b-0">
                  {{ $t("financial.未结：") }}
                  <span class="tx-white">{{
                    ($CE[item.currency] || {}).symbol +
                    formatNum(
                      Number(item.realAmount) - Number(item.partAmount),
                      4
                    )
                  }}</span>
                </p>
                <p
                  v-if="Number(item.partAmount) > Number(item.realAmount)"
                  class="tx-danger mg-b-0"
                >
                  {{ $t("financial.需退款") }}
                </p>
              </div>
              <div class="c-2 valign-middle tx-14">
                <a
                  v-if="item.reason.length > 0"
                  href="javascript:;"
                  @click="openReasonLog(item)"
                >
                  <i class="icon ion-chatbox-working tx-20 tx-info"></i>
                </a>
                <a v-else href="javascript:;">
                  <i class="icon ion-chatbox-working tx-20 tx-gray-600"></i>
                </a>
              </div>
              <div class="c-2 valign-middle tx-12">
                <span :class="item.status | statusClass">{{
                  $t(billStatusArr[item.status])
                }}</span>
              </div>
              <div class="c-2 valign-middle tx-12">
                <span :class="{ 'tx-white': item.timeSettled }">{{
                  item.timeSettled | formatDate
                }}</span>
              </div>
              <div class="c-2 valign-middle tx-12">
                <div
                  v-if="
                    (item.status == 1 ||
                      item.status == 2 ||
                      item.status == 3) &&
                    isSysRights('Bill.exportBySupplier')
                  "
                >
                  <a
                    class="tx-info"
                    href="javascript:;"
                    @click="openExport(item.id)"
                    >{{ $t("financial.导出对账单") }}</a
                  >
                </div>
              </div>
            </div>
            <!-- 子对账单总计 -->
            <div style="margin: 5px 20px" v-if="item.subBillNum > 0">
              <a
                href="javascript:;"
                class="tx-info tx-underline tx-14"
                @click="innerTableStatus(item.id)"
              >
                <i
                  class="mg-x-5 fa tx-white tx-14"
                  :class="
                    openInner[item.id] ? 'fa-minus-square' : 'fa-plus-square'
                  "
                ></i
                >{{ item.subBillNum }}{{ $t("financial.个子对账单") }}
              </a>
              <span class="mg-l-20"
                >{{ $t("financial.共涉及商品数：")
                }}<span class="tx-warning">{{ item.skuNum }}</span>
                {{ $t("financial.种") }} /
                <span class="tx-warning">{{ item.receiveNum }}</span>
                {{ $t("financial.件") }} /
                {{ ($CE[item.currency] || {}).symbol }}
                <span class="tx-warning">{{
                  formatNum(item.receivePrice, 4)
                }}</span>
                ，{{ $t("financial.其中已付款：")
                }}<span class="tx-success">{{ item.skuNumPaid }}</span>
                {{ $t("financial.种") }} /
                <span class="tx-success">{{ item.receiveNumPaid }}</span>
                {{ $t("financial.件") }} /
                {{ ($CE[item.currency] || {}).symbol }}
                <span class="tx-success">{{
                  formatNum(item.receivePricePaid, 4)
                }}</span>
                ）</span
              >
            </div>
            <!-- 子对账单列表 -->
            <div
              class="list-body mg-l-20 mg-r-20 order-pro"
              v-if="openInner[item.id]"
            >
              <div
                class="valign-middle tx-12 mg-t-10 mg-b-10"
                v-for="subBill in item.subBillList"
                :key="subBill.id"
              >
                <div class="d-flex align-items-center mg-t-5 mg-b-5">
                  <div
                    class="media d-flex align-items-center pos-relative"
                    :class="{
                      'c-6': item.billType == 2,
                      'c-8': item.billType == 3,
                    }"
                  >
                    <label class="ckbox mg-b-0 d-inline-block valign-middle">
                      <input
                        type="checkbox"
                        :value="subBill.id"
                        v-model="item.checkArr"
                      />
                      <span></span>
                    </label>
                    <div v-if="item.billType != 3">
                      {{ $t("financial.入库日期：")
                      }}<span class="tx-white">{{ subBill.dateReceived }}</span>
                    </div>
                    <div v-else>
                      {{ $t("rm.创建日期：")
                    }}<span class="tx-white">{{ subBill.timeCreated }}</span>
                    </div>
                  </div>
                  <div class="c-6">
                    {{ $t("financial.发货商品数：")
                    }}<span class="tx-white">{{ subBill.itemCnt }}</span>
                    {{ $t("financial.种") }} /
                    <span class="tx-white">{{ subBill.itemQuantity }}</span>
                    {{ $t("financial.件") }} /
                    {{ ($CE[item.currency] || {}).symbol }}
                    <span class="tx-white">{{
                      formatNum(subBill.totalAmount, 4)
                    }}</span>
                  </div>
                  <div
                    :class="{
                      'c-6': item.billType == 2,
                      'c-2': item.billType == 3,
                    }"
                  >
                    <span :class="subBill.status | statusClass">{{
                      $t(billStatusArr[subBill.status])
                    }}</span>
                  </div>
                  <div class="c-6">
                    <template v-if="subBill.status == 1">
                      {{ $t("financial.需付款日期：")
                      }}<span class="tx-white">{{
                        subBill.timeExpectedPaid
                      }}</span>
                      <span v-if="inOneDay(subBill.timeExpectedPaid)">
                        （{{ $t("financial.还剩") }}
                        <span class="tx-white"
                          ><countdownTime
                            :end-time="inOneDay(subBill.timeExpectedPaid)"
                        /></span>
                        ）
                      </span>
                      <span v-else
                        >（<span class="tx-danger">{{
                          $t("financial.已超期")
                        }}</span
                        >）</span
                      >
                    </template>
                    <template v-if="subBill.status == 2">
                      {{ $t("financial.付款日期：")
                      }}<span class="tx-white">{{ subBill.timePaid }}</span>
                    </template>
                  </div>
                </div>
                <div
                  class="d-flex align-items-center mg-t-5 mg-b-5"
                  v-for="(sub, index) in subBill.itemJson"
                  :key="index"
                >
                  <div class="c-12 d-flex align-items-center purchase-img-wrap">
                    <div class="pos-relative">
                      <a
                        href="javascript:;"
                        class="p-img-wrap pos-relative"
                        v-lazy:background-image="
                          sub.distributorProductStockImageUrl
                        "
                      ></a>
                    </div>
                    <div style="width: calc(100% - 90px)">
                      <p class="mg-b-5">
                        {{
                          $t("financial.商品名：")
                        }}{{ sub.distributorProductName }}
                      </p>
                      <p style="margin: 0">
                        <span class="mg-r-5">SKU:</span>
                        <span class="tx-gray-300 mg-r-5">{{ sub.sku }}</span>
                        <a
                          href="javascript:;"
                          :data-clipboard-text="sub.sku"
                          class="to-clipboard tx-info mg-l-5"
                          ><i class="icon ion-clipboard"></i
                        ></a>
                      </p>
                      <p class="mg-b-5">
                        {{ $t("financial.商品属性：")
                        }}{{ sub.distributorProductPropertyValue }}
                      </p>
                    </div>
                  </div>
                  <div class="c-6">
                    <div>
                      {{ $t("financial.采购单价：")
                      }}{{ ($CE[item.currency] || {}).symbol }}
                      <span class="tx-white">{{
                        formatNum(sub.price, 4)
                      }}</span>
                    </div>
                    <!-- <div>
                      {{ $t("financial.发货数量：") }}
                      <span class="tx-white">{{ sub.shippingQuantity }}</span>
                    </div> -->
                    <div>
                      {{ $t("financial.包材费：")}}{{ ($CE[item.currency] || {}).symbol }}
                      <span class="tx-white">{{ formatNum(sub.packagingFee, 4)}}</span>
                    </div>
                    <div v-if="item.billType == 3">
                      {{ $t("financial.发货数量：") }}
                      <span class="tx-white">{{ sub.shippingQuantity }}</span>
                    </div>
                    <div v-else>
                      {{ $t("financial.入库数量：") }}
                      <span class="tx-white">{{ sub.receivedQuantity }}</span>
                    </div>
                  </div>
                  <div class="c-6">
                    {{ $t("financial.结算金额：")
                    }}{{ ($CE[item.currency] || {}).symbol }}
                    <span class="tx-white">{{
                      formatNum(sub.totalPrice, 4)
                    }}</span>
                  </div>
                </div>
              </div>
              <div
                class="
                  d-flex
                  align-items-center
                  justify-content-end
                  mg-t-10 mg-b-10
                "
                v-if="isSysRights('SubBill.exportSubBill')"
              >
                <a
                  href="javascript:;"
                  class="btn btn-primary mg-r-15"
                  @click="exportSubBill(item)"
                >
                  {{ $t("financial.导出选择的子对账单") }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="(!items || items.length < 1) && !first_loading"
        class="nodata mg-t-50 mg-b-50 text-center tx-24"
      >
        <i class="fa fa-ban"></i>{{ $t("financial.没有符合条件的账单") }}
      </div>
    </div>
    <!-- 订单详情 -->
    <modalOrderDetails :dialog="orderDetailsDialog"></modalOrderDetails>
  </div>
</template>

<script>
import countdownTime from "./countdownTime.vue";
import modalOrderDetails from "./modal-order-details";

export default {
  components: { countdownTime, modalOrderDetails },
  props: ["first_loading", "items", "check_arr"],
  data() {
    return {
      billStatusArr: arrDict.billStatus,
      checkArr: [],
      openInner: [],
      orderDetailsDialog: {
        visible: false,
        loading: false,
        item: {},
      },
    };
  },
  filters: {
    statusClass(val) {
      val = val - 0;
      let style = "";
      switch (val) {
        case 1:
          style = "tx-white";
          break;
        case 2:
          style = "tx-success";
          break;
        case 3:
          style = "tx-warning";
          break;
        case 9:
          style = "tx-gary";
          break;
      }
      return style;
    },
    formatDate(val) {
      if (!val) return "----";
      return moment(val, "YYYY-MM-DD hh:mm:ss").format("YYYY-MM-DD");
    },
  },
  computed: {
    isAll() {
      return this.checkArr.length == this.items.length && this.items.length > 0
        ? true
        : false;
    },
  },
  updated() {
    $('[data-toggle="tooltip-primary"]').tooltip({
      template:
        '<div class="tooltip tooltip-primary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
    });
  },
  watch: {
    check_arr: function () {
      this.checkArr = this.check_arr;
    },
    checkArr: function () {
      this.$emit("changeChecked", this.checkArr);
    },
  },
  methods: {
     attachment(item) {
      this.$emit('attachment', item)
    },
    // 打开订单详情
    openOrderDetails(item) {
      this.orderDetailsDialog.item = item;
      this.orderDetailsDialog.visible = true;
    },
    // 格式化时间
    inOneDay(date) {
      const day = moment(date).add(1, "days").locale("zh-cn");
      const is = moment().isBefore(day);
      if (is) {
        return day.format();
      }
      return false;
    },
    // 导出选择的子对账单
    exportSubBill(item) {
      if ((item.checkArr || []).length == 0)
        return ShowTip(this.$t("financial.请选择需要导出的子对账单"), "danger");
      this.$emit("exportSubBill", item);
    },
    popContact(event, item, id, position) {
      this.$emit("popContact", event, item, id, position);
    },
    openReasonLog(obj) {
      this.$emit("openReasonLog", obj);
    },
    openLog(obj) {
      this.$emit("openLog", obj);
    },
    changeAllCheck(e) {
      this.checkArr = [];
      if (e.target.checked) {
        this.items.forEach((e) => {
          this.checkArr.push(e.id);
        });
      }
    },
    openOrderList(obj) {
      //打开订单列表
      this.$emit("openOrderList", obj);
    },
    openExport(id) {
      //打开导出模态框
      this.$emit("openExport", id);
    },
    /**
     * 控制子对账单的显示与隐藏
     */
    innerTableStatus(i) {
      this.$set(this.openInner, i, !this.openInner[i]);
    },
  },
};
</script>

<style lang="less" scoped>
.card .order-pro {
  background-color: #1a2432;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.show-white-style .card .order-pro {
  background-color: #e6e6e6;
  border: 1px solid #dee2e6;
}

.purchase-img-wrap .pos-relative {
  width: 80px;
  height: 80px;
  margin-right: 10px;
}

.purchase-img-wrap .pos-relative .p-img-wrap {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  margin-right: 0;
  background-color: #fff;
  transform: scale(0.9, 0.9);
}
</style>
